export const generateNonce = () => {
  const array = crypto.getRandomValues(new Uint8Array(32))

  const nonce = ("0x" +
    Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
      ""
    )) as `0x${string}`

  return nonce
}
